import { render } from "./RecommendedVouchersPage.vue?vue&type=template&id=03536de8&scoped=true"
import script from "./RecommendedVouchersPage.vue?vue&type=script&lang=js"
export * from "./RecommendedVouchersPage.vue?vue&type=script&lang=js"

import "./RecommendedVouchersPage.vue?vue&type=style&index=0&id=03536de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03536de8"]])

export default __exports__